import { useMemo } from "react";
import { useLocationStore, useMapStore } from "..";
import useLocationsWithGlobalFilters from "./useLocationsWithGlobalFilters";
import { ILocationWithIcon } from "./useVisibleLocationsOnMap";

export default function useRadiusLocationsOnMap(): ILocationWithIcon[] {
    const locationStore = useLocationStore();
    const mapStore = useMapStore();

    const radiusLocations = useMemo(() => {
        const radiusLocationIdSet = new Set(locationStore.radiusLocationIds);
        return locationStore.locations.filter(l => radiusLocationIdSet.has(l.id));
    }, [locationStore.locations, locationStore.radiusLocationIds]);

    const locations = useLocationsWithGlobalFilters(radiusLocations);

    return useMemo(() => locations.map(l => ({
        ...l,
        icon: mapStore.loadedLogoCompanyIds.includes(l.pipedriveCompanyId)
            ? `location-marker-company-${l.pipedriveCompanyId}`
            : "location-marker",
    })), [locations, mapStore.loadedLogoCompanyIds]);
}
